export const getTimeToShow = (date: Date) => {
  const currentDate = new Date()

  // If today, return time in 12-hour format
  if (
    date.getDate() === currentDate.getDate() &&
    date.getMonth() === currentDate.getMonth()
  ) {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
    })
  }

  // else // else, March 12, 2023
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
}

export const getDateFromTimeRange = (timeRange: string): Date => {
  const currentDate = new Date()

  switch (timeRange) {
    case '1d':
      return new Date(currentDate.setDate(currentDate.getDate() - 1))
    case '1w':
      return new Date(currentDate.setDate(currentDate.getDate() - 7))
    case '1m':
      return new Date(currentDate.setMonth(currentDate.getMonth() - 1))
    case '3m':
      return new Date(currentDate.setMonth(currentDate.getMonth() - 3))
    default:
      return new Date(currentDate.setDate(currentDate.getDate() - 1)) // Default to 1 day
  }
}
